import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8qax1plboc: FaireBrandEntity = {
  token: "b_8qax1plboc",
  type: "brand",
  name: "Nickel and Suede",
  avatarUrl:
    "https://cdn.faire.com/fastly/1065cdd35ce1330623a9c0b29033dd74ae189a5ec81bdecb8bafe73093b12e69.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c0ea85745e6cb2a0ccc61ee59542225323f783d42c2c74a6fb60cb1507083e33.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1065cdd35ce1330623a9c0b29033dd74ae189a5ec81bdecb8bafe73093b12e69.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c0ea85745e6cb2a0ccc61ee59542225323f783d42c2c74a6fb60cb1507083e33.jpeg",
  location: "Kansas City, MO, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 39,
  isTopShop: true,
  isInsider: true,
  description:
    "Nickel & Suede is a jewelry and accessories company founded by influencer @kileenickels with the mission to create jewelry that makes you feel good. We use premium lightweight, Italian leather and high quality metals so that our pieces always look and feel good. Always nickel free, tarnish resistant and hypoallergenic, our pieces are intended to spark creativity and offer just the right thing to finish any outfit.\n\nWhat once began as a side project run out of the Nickels’ small basement workshop has now evolved into a national brand with three retail locations, and a design office and production facility based in Kansas City. Nickel & Suede has been recognized as one of Inc. 500’s Fastest Growing Companies nationally and #1 in the Midwest. With over a million pairs sold, N&S is just getting started.\n\nExpanding beyond earrings, Nickel & Suede now offers officially licensed jewelry and accessories for college, professional, and high school teams, bringing a fresh, fashion-forward take to game day style. Additionally, the brand specializes in custom designs, creating unique jewelry for corporate gifting, events, and more.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:32.126Z",
    importedBy: "entity-db-cli",
  },
};
